import { parseISO } from 'date-fns';

export function parseDateString(dateOrString: string | Date): Date {
  if (typeof dateOrString === 'string') {
    return parseISO(dateOrString);
  }
  return dateOrString;
}

export function parseDateStringIgnoreTime(dateOrString: string | Date): Date {
  if (typeof dateOrString === 'string') {
    return parseISO(dateOrString.substring(0, 10));
  }
  return dateOrString;
}

/**
 * Returns the date portion of the given date object, using local time (yyyy-MM-dd)
 */
export function getISODateString(
  date: Date | string,
  granularity: 'day' | 'month' | 'year' = 'day'
): string {
  if (!date) {
    return '';
  }

  const parsed = parseDateStringIgnoreTime(date);

  const monthNum = granularity === 'year' ? 1 : parsed.getMonth() + 1;
  const dayNum = granularity === 'day' ? parsed.getDate() : 1;

  const year = parsed.getFullYear();
  const month = monthNum.toString().padStart(2, '0');
  const day = dayNum.toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function tryGetISODateString(
  date: string,
  granularity: 'day' | 'month' | 'year' = 'day'
): string {
  try {
    return getISODateString(date, granularity);
  } catch {
    return date;
  }
}

// TDT-88: Format date as MM/DD/YYYY without timezone conversion
export function formatDateWithoutTimezone(dateValue: any): string {
  if (!dateValue) return '';

  try {
    const dateStr =
      typeof dateValue === 'string' ? dateValue : dateValue.toString();

    // Extract just the date part (YYYY-MM-DD)
    const dateMatch = dateStr.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (dateMatch) {
      const [, year, month, day] = dateMatch;
      return `${month}/${day}/${year}`;
    }

    const date = new Date(dateValue);
    if (!isNaN(date.getTime())) {
      // Use UTC methods to avoid timezone conversion
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${month}/${day}/${year}`;
    }

    return '';
  } catch {
    return dateValue;
  }
}
